import React from "react";

export const SwitchButton = ({
  title,
  values,
  matchingReduxState,
  onStateChange,
}) => {
  return (
    <div className="switchButtonContainer">
      <label className="switchButtonTitle">{title}:</label>
      <div className="switchButton">
        <button
          className={`switchButtonLeft ${
            matchingReduxState === values[0].value ? "switchButtonActive" : ""
          }`}
          onClick={async () => {
            onStateChange(values[0].value);
          }}
        >
          <p className="switchButtonText">{values[0].name}</p>
        </button>
        <button
          className={`switchButtonRight ${
            matchingReduxState === values[1].value ? "switchButtonActive" : ""
          }`}
          onClick={async () => {
            onStateChange(values[1].value);
          }}
        >
          <p className="switchButtonText">{values[1].name}</p>
        </button>
      </div>
    </div>
  );
};
